module.exports = __webpack_public_path__ + "img/comunicacion-en-linea.fd73933f.png";